<template>
  <v-dialog v-model="isOpen" max-width="360">
    <v-card>
      <!--- TODO check if using a library for cropping pictures before uploading is possible (vue-advanced-cropper)
          https://osmantamer.medium.com/vue-js-crop-upload-and-display-profile-picture-6bffb2e79fae
          DEMO: https://osmantamer.github.io/vue-avatar-demo/ --->

      <v-card-title class="headline">{{ $t('title.editAvatar') }}</v-card-title>

      <div class="container">
        <!--- TODO aesthetics: adapt font size --->
        <v-avatar color="primary darken-1" size="150">
          <img v-if="currentImage" :src="currentImage" class="primary" />
          <span v-else class="white--text headline">{{ initials }}</span>
        </v-avatar>
      </div>
      <v-spacer></v-spacer>
      <div class="container">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-file-input
              accept="image/*"
              v-model="image"
              prepend-icon="mdi-camera"
              @change="addImagePreview"
              class="d-none"
              ref="fileInput"
            ></v-file-input>
            <v-btn v-on="on" class="mx-2" fab dark small color="primary" @click="triggerFileInput">
              <v-icon> mdi-camera </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('button.selectImage') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="mx-2" fab dark small color="secondary" @click="removeImagePreview">
              <v-icon dark> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('button.deleteImage') }}</span>
        </v-tooltip>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!canSave" text @click="saveProfilePicture()">
          {{ $t('button.save') }}
        </v-btn>
        <v-btn text @click="isOpen = false">
          {{ $t('cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { preprocessImage } from '@/common/mediaUtils';
import { mapState } from 'vuex';
import localStorageManager from '../../services/browserStorageService.js';

export default {
  name: 'ProfilePictureDialog',
  props: {
    employee: Object,
    initials: String,
    photoUrl: String,
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.value,
      profilePictureDeleted: false,
      newBase64Image: null,
      localStorageImage: localStorageManager.getEmployeeAvatar(),
      image: null,
    };
  },
  computed: {
    ...mapState({
     isConnected: (state) => state.isConnected,
    }),
    currentImage() {
      if (this.newBase64Image) return this.newBase64Image;
      if (this.localStorageImage === 'deleted') return null;
      if (this.localStorageImage) return this.localStorageImage;
      if (this.photoUrl && !this.profilePictureDeleted && this.isConnected) return this.photoUrl;
      return null;
    },
    canSave() {
      return this.newBase64Image !== null || this.profilePictureDeleted;
    },
  },
  methods: {
    async addImagePreview() {
      if (this.image && this.image.size > 0) {
        this.newBase64Image = await preprocessImage(this.image);
        this.profilePictureDeleted = false;
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.$el.querySelector('input').click();
    },
    removeImagePreview() {
      this.resetData();
      this.profilePictureDeleted = true;
      this.localStorageImage = null;
    },
    resetData() {
      this.newBase64Image = null;
      this.profilePictureDeleted = false;
      this.image = null;
    },
    async saveProfilePicture() {
      await this.$store.dispatch('employee/storeProfilePicture', {
        profilePictureBase64Image: this.newBase64Image,
        employeeNr: this.employee.employeeNr,
      });

      if (!this.isConnected) {
        if (this.newBase64Image) localStorageManager.setEmployeeAvatar(this.newBase64Image);
        else localStorageManager.setEmployeeAvatar('deleted');
        this.localStorageImage = localStorageManager.getEmployeeAvatar();
      } else {
        await this.$store.dispatch('sync/synchronizeAppIfNotSynching', {});
        localStorageManager.clearEmployeeAvatar();
      }

      await this.$store.dispatch('sync/invalidateModuleCacheAndSync', { moduleId: 'employee' }, { root: true });
      this.isOpen = false;
    },
  },
  watch: {
    isOpen(newValue, oldValue) {
      this.$emit('input', newValue);
      if (!newValue && oldValue) {
        this.resetData();
      }
    },
    value(newValue, oldValue) {
      this.isOpen = newValue;
    },
  },
};
</script>
<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
